'use strict';

var React = require('react');
var HalfCard = require('@swiggy-private/dls-web-core/dist/components/HalfCard');
var jsUtils = require('@swiggy-private/js-utils');
var SpriteIconWeb = require('@swiggy-private/dls-web-food-icons/dist/SpriteIconWeb');
var styled = require('styled-components');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var Image = require('@swiggy-private/dls-web-core/dist/components/Image');
var Popup = require('@swiggy-private/dls-web-core/dist/components/Popup');
var Rating = require('./Rating-Dy9qwprD.js');
var PriceV4 = require('./PriceV4-CAdVMHnO.js');
var OffertagV4 = require('./OffertagV4-CLotnX1F.js');
var components_FoodItem_helpers_index = require('./index-2bhV6eMA.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Content = styled__default.default.div(({ theme, hasImage }) => (Object.assign({ display: "flex", justifyContent: "space-between", padding: `${theme.spacing.medium} ${theme.spacing.medium}`, paddingBottom: theme.spacing.small }, (!hasImage && {
    paddingTop: theme.spacing.xxLarge,
}))));
const ImageContainer = styled__default.default.figure(({ theme, isDweb }) => (Object.assign({ overflow: "hidden", fontSize: 0, minHeight: "250px", maxHeight: "80vw", padding: 0, margin: 0 }, (isDweb && {
    margin: 0,
    height: "400px",
    width: "500px",
    borderRadius: `${theme.cornerRadius.xLarge} ${theme.cornerRadius.xLarge} 0 0`,
}))));
const IconContainer = styled__default.default.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing.xxSmall,
}));
const ItemName = styled__default.default(Text.Text)({
    wordBreak: "break-word",
});
const ItemPriceContainer = styled__default.default.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing.xxSmall,
}));
const DescriptionHeading = styled__default.default(Text.Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}  ${theme.spacing.xSmall} ${theme.spacing.medium}`,
}));
const Description = styled__default.default(Text.Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}  ${theme.spacing.xxLarge} ${theme.spacing.medium}`,
}));
const IngredientDescriptionContainer = styled__default.default.ul(({ theme }) => ({
    margin: 0,
    paddingLeft: theme.spacing.xxxSmall,
}));
const IngredientDescription = styled__default.default(Text.Text)(({ theme }) => ({
    margin: `0 ${theme.spacing.medium} ${theme.spacing.xxxSmall} ${theme.spacing.medium}`,
    listStyleType: "disc",
    padding: 0,
    position: "relative",
    paddingLeft: "1em",
    "&::before": {
        content: '"•"',
        position: "absolute",
        left: 0,
    },
    "&:last-child": {
        marginBottom: theme.spacing.medium,
    },
}));
const AddButtonContainer = styled__default.default.div(({ theme }) => ({
    marginLeft: theme.spacing.small,
    maxHeight: "144px",
}));
const GuiltFreeIcon = styled__default.default.div(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
}));
const BestsellerIcon = styled__default.default.div(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
    lineHeight: "0",
}));
const ImageCard = styled__default.default(Image.Image)({
    width: "100%",
    minHeight: "250px",
});
const DetailsContainer = styled__default.default.div(({ backgroundColor, theme }) => ({
    backgroundColor: backgroundColor
        ? backgroundColor[theme.colorMode]
        : "transparent",
}));

const ItemOverlay = ({ imageId, imageUrl, vegType, item, addButtonRenderer, price, finalPrice, description, afterClose, showOverlay, isBestseller, fallbackBackground, offerTags, ratings, isGuiltfree, isDweb = false, showDescription = true, itemDetails, ingredients, backgroundColor, }) => {
    const hasImage = !jsUtils.isEmpty(imageId) || !jsUtils.isEmpty(imageUrl);
    const Details = React.useCallback(() => {
        var _a, _b;
        return (React__default.default.createElement(DetailsContainer, { backgroundColor: backgroundColor },
            hasImage && (React__default.default.createElement(ImageContainer, { style: fallbackBackground, isDweb: isDweb },
                React__default.default.createElement(ImageCard, { cloudinaryId: imageId, cloudinaryHeight: 600, src: imageId ? undefined : imageUrl, alt: item, fit: isDweb ? "fill" : "cover" }))),
            React__default.default.createElement(Content, { hasImage: hasImage },
                React__default.default.createElement("div", null,
                    React__default.default.createElement(IconContainer, { "aria-hidden": true },
                        React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: vegType === 1 ? "vegVeg16" : "nonvegNonVeg16" }),
                        isBestseller && (React__default.default.createElement(BestsellerIcon, null,
                            React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: "bestseller16", width: "74" })))),
                    React__default.default.createElement(ItemName, { color: "text_High_Emphasis", variant: "V2.subheading1.neutral.bold", "aria-hidden": "true" },
                        React__default.default.createElement(React__default.default.Fragment, null, item)),
                    React__default.default.createElement(ItemPriceContainer, null,
                        React__default.default.createElement(PriceV4.PriceV4, { price: price, finalPrice: finalPrice }),
                        React__default.default.createElement(OffertagV4.OfferTagV4, { offers: offerTags })),
                    !jsUtils.isEmpty(ratings) && !jsUtils.isEmpty(ratings === null || ratings === void 0 ? void 0 : ratings.aggregatedRating) && (React__default.default.createElement(Rating.Ratings, { rating: ((_a = ratings === null || ratings === void 0 ? void 0 : ratings.aggregatedRating) === null || _a === void 0 ? void 0 : _a.rating) || "", ratingCount: ((_b = ratings === null || ratings === void 0 ? void 0 : ratings.aggregatedRating) === null || _b === void 0 ? void 0 : _b.ratingCountV2) || "" })),
                    isGuiltfree && (React__default.default.createElement(GuiltFreeIcon, null,
                        React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: "guiltfree24", width: "61" })))),
                React__default.default.createElement(AddButtonContainer, { "aria-hidden": true }, addButtonRenderer(false))),
            showDescription && (React__default.default.createElement(Description, { color: "text_Med_Emphasis", variant: "V2.body1.neutral.regular" }, description)),
            itemDetails && (React__default.default.createElement(React__default.default.Fragment, null,
                React__default.default.createElement(DescriptionHeading, { color: "text_High_Emphasis", variant: "V2.body2.neutral.bold" }, components_FoodItem_helpers_index.ITEM_DESCRIPTION_HEADING_TEXT),
                React__default.default.createElement(Description, { color: "text_Med_Emphasis", variant: "V2.body1.neutral.regular" }, itemDetails))),
            (ingredients === null || ingredients === void 0 ? void 0 : ingredients.length) && (React__default.default.createElement(React__default.default.Fragment, null,
                React__default.default.createElement(DescriptionHeading, { color: "text_High_Emphasis", variant: "V2.body2.neutral.bold" }, components_FoodItem_helpers_index.INGREDIENT_HEADING_TEXT),
                React__default.default.createElement(IngredientDescriptionContainer, null, ingredients.map((ing) => (React__default.default.createElement(IngredientDescription, { color: "text_Med_Emphasis", variant: "V2.body1.neutral.regular" }, ing))))))));
    }, [
        addButtonRenderer,
        description,
        fallbackBackground,
        finalPrice,
        hasImage,
        imageId,
        imageUrl,
        ingredients,
        isBestseller,
        isDweb,
        isGuiltfree,
        item,
        itemDetails,
        offerTags,
        price,
        ratings,
        showDescription,
        vegType,
        backgroundColor,
    ]);
    if (!isDweb) {
        return (React__default.default.createElement(HalfCard.HalfCard, { isOpen: showOverlay, onClose: afterClose, hasCustomPadding: true },
            React__default.default.createElement(Details, null)));
    }
    return (React__default.default.createElement(Popup.Popup, { isOpen: showOverlay, onClose: afterClose, width: "500px", zIndex: 12000, hasCustomPadding: true, hideCloseIcon: false },
        React__default.default.createElement(Details, null)));
};
var ItemOverlayV4 = React.memo(ItemOverlay);

exports.ItemOverlayV4 = ItemOverlayV4;
//# sourceMappingURL=ItemOverlay-C97dK9uZ.js.map
